<template>
  <div :class="$style.category_list">
    <!-- TODO: 製品の性別区分の方針が定まっていないため、暫定で非表示 -->
    <!-- <p :class="$style.category_list_head">性別から選ぶ</p>
    <ul :class="$style.category_list_box_section">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/sex_unisex.png"
        sp-img-url="/images/site/product_scene/sex_unisex_sp.png"
        title="ユニセックス"
        @update:item-update-filter="updateFilter('sex', 'unisex')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/sex_ladies.png"
        sp-img-url="/images/site/product_scene/sex_ladies_sp.png"
        title="女性"
        @update:item-update-filter="updateFilter('sex', 'ladies')"
      />
    </ul> -->

    <p :class="$style.category_list_head">季節から選ぶ</p>
    <ul :class="$style.category_list_box_section">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/season_ss.png"
        sp-img-url="/images/site/product_scene/season_ss_sp.png"
        title="春〜夏"
        @update:item-update-filter="updateFilter('season', 'ss')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/season_fw.png"
        sp-img-url="/images/site/product_scene/season_fw_sp.png"
        title="秋〜冬"
        @update:item-update-filter="updateFilter('season', 'fw')"
      />
    </ul>

    <p :class="$style.category_list_head">素材から選ぶ</p>
    <p :class="$style.category_list_sub_head">すずしい</p>
    <ul :class="[$style.category_list_box_section, $style.sub_head_border]">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_dry.png"
        sp-img-url="/images/site/product_scene/material_dry_sp.png"
        title="ドライ"
        @update:item-update-filter="updateFilter('fabric', 'dry')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_mesh.png"
        sp-img-url="/images/site/product_scene/material_mesh_sp.png"
        title="メッシュ"
        @update:item-update-filter="updateFilter('fabric', 'mesh')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_pile.png"
        sp-img-url="/images/site/product_scene/material_pile_sp.png"
        title="パイル"
        @update:item-update-filter="updateFilter('fabric', 'pile')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_waffle.png"
        sp-img-url="/images/site/product_scene/material_waffle_sp.png"
        title="ワッフル"
        @update:item-update-filter="updateFilter('fabric', 'waffle')"
      />
    </ul>

    <p :class="$style.category_list_sub_head">やわらか</p>
    <ul :class="[$style.category_list_box_section, $style.sub_head_border]">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_gauze.png"
        sp-img-url="/images/site/product_scene/material_gauze_sp.png"
        title="ガーゼ"
        @update:item-update-filter="updateFilter('fabric', 'gauze')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_soft_knit.png"
        sp-img-url="/images/site/product_scene/material_soft_knit_sp.png"
        title="ソフトニット"
        @update:item-update-filter="updateFilter('fabric', 'soft-knit')"
      />
    </ul>

    <p :class="$style.category_list_sub_head">あたたかい</p>
    <ul :class="[$style.category_list_box_section, $style.sub_head_border]">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_sweat.png"
        sp-img-url="/images/site/product_scene/material_sweat_sp.png"
        title="スウェット"
        @update:item-update-filter="updateFilter('fabric', 'sweat')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_urakimou_sweat.png"
        sp-img-url="/images/site/product_scene/material_urakimou_sweat_sp.png"
        title="裏起毛スウェット"
        @update:item-update-filter="updateFilter('fabric', 'lining-sweat')"
      />
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_velor.png"
        sp-img-url="/images/site/product_scene/material_velor_sp.png"
        title="ベロア"
        @update:item-update-filter="updateFilter('fabric', 'velor')"
      />
    </ul>

    <p :class="$style.category_list_sub_head">ラグジュアリー</p>
    <ul :class="[$style.category_list_box_section, $style.sub_head_border]">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_satin.png"
        sp-img-url="/images/site/product_scene/material_satin.png"
        title="サテン"
        @update:item-update-filter="updateFilter('fabric', 'satin')"
      />
    </ul>

    <p :class="$style.category_list_sub_head">プレミアムライン</p>
    <ul :class="$style.category_list_box_section">
      <ProductCategoryIndexListItem
        img-url="/images/site/product_scene/material_premium_pile.png"
        sp-img-url="/images/site/product_scene/material_premium_pile_sp.png"
        title="プレミアムパイル"
        @update:item-update-filter="updateFilter('fabric', 'premium-pile')"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { ProductTabBarMode } from "~/types/product"
import type { ApiProductSearchQuery } from "~/types/server/api/product"

defineProps<{
  filter: ApiProductSearchQuery
}>()

const emit = defineEmits<{
  (e: "update:filter", query: ApiProductSearchQuery, tabValue: ProductTabBarMode): void
}>()

const updateFilter = (selectType: keyof ApiProductSearchQuery, value: string) => {
  emit(
    "update:filter",
    {
      [selectType]: value,
    },
    "all",
  )
}
</script>

<style scoped module lang="scss">
.category_list_head {
  font-size: $font-size-16;
  font-weight: bold;
  color: $btn-bg-primary;
  margin: 0 auto 1rem;
  text-align: center;
  padding: 0.5rem 0;
  background: #eef2f7;
}

.category_list_sub_head {
  font-size: $font-size-15;
  font-weight: bold;
  color: $btn-bg-primary;
  margin: 0 auto 0.5rem;
  text-align: center;
  padding: 0.5rem 0;
  background: #fff;
}

.sub_head_border {
  padding-bottom: 1rem;
  border-bottom: 1px solid $primary-20;
}

.category_list {
  width: 100%;
  margin: 1rem auto 0;
  .category_list_box_section {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: calc(20rem + 0.555rem);
    column-gap: 0.525rem;
    row-gap: 0.525rem;
    list-style: none;
    margin: 0 auto 0.925rem;

    @include md {
      width: 100%;
    }
  }
}
</style>
